import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Select } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { TypeConteneurMobileDto, ZoneGeographiqueDto } from 'src/api/models';
import { ControlPanelStore } from 'src/states/control-panel.store';
import { DevExtremeTranslationService } from '../../../services/devExtremeTranslation.service';

@Component({
  selector: 'app-type-conteneur-mobile-select',
  templateUrl: './type-conteneur-mobile-select.component.html',
  styleUrls: ['./type-conteneur-mobile-select.component.css']
})
export class TypeConteneurMobileSelectComponent implements OnInit, OnDestroy {
  @Select(ControlPanelStore.typesConteneursMobiles$) typesConteneursMobiles$: Observable<TypeConteneurMobileDto[]>;

  @Input('width') width: number;
  @Input('disabled') disabled: boolean = false;
  @Input() typeConteneurMobileId: number;
  @Output() typeConteneurMobileIdChange = new EventEmitter<number>();

  @Input() cell: any;

  InitId = null;

  TypesConteneursMobiles: TypeConteneurMobileDto[] = [];

  tc: Subscription;

  constructor(
    private translate: TranslateService,
    private devExtremeTranslationService: DevExtremeTranslationService)
  {
    // Instanciate Globalize for DevExtreme components
    this.devExtremeTranslationService.loadLanguage(this.translate.getBrowserLang());
  }

  ngOnInit() {
    if (this.typeConteneurMobileId != null) {
      this.InitId = JSON.parse(JSON.stringify(this.typeConteneurMobileId));
    }
    this.tc = this.typesConteneursMobiles$.subscribe(res => {
      if (res != null) {
        this.TypesConteneursMobiles = res;
      }
    });
  }

  ngOnDestroy() {
    this.tc?.unsubscribe();
  }

  updateInfo(event) {
    if (!!this.cell && this.InitId != this.typeConteneurMobileId) {
      this.cell.setValue(this.typeConteneurMobileId);
    }
    this.typeConteneurMobileIdChange.emit(this.typeConteneurMobileId);
  }
}
